import anchorme from 'anchorme';

import type { BlockType } from 'shared-types';

interface Params<T> {
  adminUrl: string;
  courseSlug: string;
  data: T;
  type: BlockType;
}

const getDataWithUpdatedLinks = <T>({
  adminUrl,
  courseSlug,
  data,
  type
}: Params<T>) => {
  const linkBlocks = [
    'discussion',
    'fillin',
    'heading',
    'likert',
    'list',
    'multiplechoice',
    'openquestion',
    'numericquestion',
    'quote',
    'sequencing',
    'table',
    'text'
  ];
  if (!linkBlocks.includes(type)) return data;

  let newData = JSON.stringify(data);
  newData = newData.replace(/<a href=\\"([^"]*)\\">/g, (match, p1) => {
    let url = p1.replace(' ', ''); // clean up spaces inside urls
    let attributes = 'target=\\"_blank\\" rel=\\"noopener\\"';
    if (url.startsWith(`${adminUrl}/courses/${courseSlug}/`)) {
      attributes += ` data-reader-internal-link=\\"${url.replace(
        adminUrl,
        ''
      )}\\"`;
    }
    if (url.indexOf('http') !== 0 && url.indexOf('//') !== 0) {
      if (anchorme.validate.url(url)) url = `http://${url}`;
      else attributes = '';
    }

    return `<a href=\\"${url}\\" ${attributes}>`;
  });

  return JSON.parse(newData) as T;
};

export default getDataWithUpdatedLinks;
